<template>
    <div class="investor-wrap">
        <div class="investor_top">
            <div class="block">
                <el-date-picker
                v-model="searchForm.datePicker"
                type="datetimerange"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="right">
                </el-date-picker>
                <el-select v-model="searchForm.investor_id" placeholder="请选择">
                    <el-option v-for="item in investorData" 
                    :key="item.investor_id"
                    :value="item.investor_id"
                    :label="item.investor_name"></el-option>
                </el-select>
            </div>
            <div style="margin-left: 10px;">
                <el-button
                size="small"
                type="primary"
                icon="el-icon-search"
                @click="getDataList"
                >查询</el-button
                >
                <el-button
                size="small"
                type="warning"
                icon="el-icon-plus"
                @click="handleAddInvertor"
                >新增</el-button
                >
            </div>
        </div>
        
        <el-row :gutter="24">
            <el-col :span="6">
                <div class="box">
                    <div class="box_num">
                        <div class="title_color">投资资金</div>
                        <div class="text_color">
                            <span>{{ investorInfo.investor_amount }}</span>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="box">
                    <div class="box_num">
                        <div class="title_color">资金租赁中</div>
                        <div class="text_color">
                            <span>{{ investorInfo.total_price }}</span>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="box">
                    <div class="box_num">
                        <div class="title_color">租赁台数</div>
                        <div class="text_color">
                            <span>{{ investorInfo.shouji_num }}</span>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="box">
                    <div class="box_num">
                        <div class="title_color">资料回款</div>
                        <div class="text_color">
                            <span>{{ investorInfo.huikuan }}</span>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="box">
                    <div class="box_num">
                        <div class="title_color">流动资金</div>
                        <div class="text_color">
                            {{ investorInfo.liudong}} 
                        </div>
                    </div>
                </div>
               
            </el-col>
            <el-col :span="6">
                <div class="box">
                    <div class="box_num">
                        <div class="title_color">逾期率</div>
                        <div class="text_color">
                            {{ investorInfo.yuqi}} 
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
        <el-dialog title="资方新增" :visible="showAddDialog">
            <el-form :model="addForm" label-width="100px">
                <el-form-item label="名称">
                    <el-input v-model="addForm.investor_name" style="width: 300px;"></el-input>
                </el-form-item>
                <el-form-item label="联系方式">
                    <el-input v-model="addForm.investor_mobile" style="width: 300px;"></el-input>
                </el-form-item>
                <el-form-item label="投资资金">
                    <el-input v-model="addForm.investor_amount" style="width: 300px;"></el-input>
                </el-form-item>
                <el-form-item label="投资时间">
                    <el-date-picker v-model="addForm.investor_time" type="datetime" value-format="timestamp" placeholder="选择日期"></el-date-picker>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="addForm.investor_content" style="width: 300px;"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button type="primary" @click="handleConfirm">确定</el-button>
                <el-button @click="showAddDialog = false">取消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import investorApi from '../../../api/investor';
import { formatDate } from "@/utils/DateTime.js";

export default {
    data(){
        let endDate = new Date();
        let startDate = new Date();
        startDate.setTime(startDate.getTime() - 3600 * 1000 * 24 * 0);
        return{
            searchForm:{
                datePicker:[
                    formatDate(startDate, "yyyy-MM-dd 00:00:00"),
                    formatDate(endDate, "yyyy-MM-dd 23:59:59")
                ],
                investor_id:0
            },
            investorInfo:{},
            showAddDialog:false,
            addForm:{
                investor_name:null,
                investor_mobile:'',
                investor_amount:'',
                investor_time:'',
                investor_content:''
            },
            investorData:[]
        }
    },
    created(){
        this.getChooseList();
        this.getDataList()
    },
    methods:{
        // 确定
        handleConfirm(){
            let params = {};
            params.investor_name = this.addForm.investor_name;
            params.investor_mobile = this.addForm.investor_mobile;
            params.investor_amount = this.addForm.investor_amount;
            params.investor_time = this.addForm.investor_time;
            params.investor_content = this.addForm.investor_content;
            investorApi.investorAdd(params).then(res=>{
                if(res.code == 1){
                    this.$message.success(res.msg);
                    this.getChooseList();
                    this.getDataList();
                    this.showAddDialog = false;
                }else{
                    this.$message.error(res.msg);
                }
              
            }).catch(err=>{
                console.log(err);
            })
        },
        // 新增
        handleAddInvertor(){
            this.showAddDialog = true;
            this.addForm = {
                investor_name:null,
                investor_mobile:'',
                investor_amount:'',
                investor_time:null,
                investor_content:''
            }
        },
        // 资方选择
        getChooseList(){
            investorApi.investorList().then(res=>{
                this.investorData = res.data.list
            }).catch(err=>{
                console.log(err);
            })
        },
        // 资方数据
        getDataList(){
            let params = {};
            params.start_time = this.searchForm.datePicker[0];
            params.end_time = this.searchForm.datePicker[1];
            params.investor_id = this.searchForm.investor_id;
            investorApi.investorIndex(params).then(res=>{
                this.investorInfo = res.data;
            }).catch(err=>{
                console.log(err);
            })
        },

    }

}
</script>

<style lang="scss" scoped>
.investor-wrap{
    .investor_top{
        width: 100%;
        background: #f1f4f6;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        padding: 10px;
    }
}
.box{
    height: 156px;
    padding: 24px;
    border: 1px solid #eee;
    margin: 15px 10px;
    
    .box_num{
        font-size: 14px;
        color: #66b1ff;
        .title_color{
            color: #333;
            font-size: 14px;
            // margin-bottom: 15px;
        }
        .text_color{
            color: #4f9dec;
            margin-top: 40px;
            span{
                font-size: 20px;
                margin-left: 5px;
            }
        }
    }
}

</style>


// WEBPACK FOOTER //
// src/views/investor/investor/index.vue